import React from 'react'
import { connect } from 'react-redux'
import RepositorySelect from './../../modules/RepositorySelect'
import Page, { RepositorySelectGroup } from './RepositorySelect'
import { withRouter } from 'react-router'

const mapStateToProps = state => {

  // If we don't have the info return early
  if (!state.user || !state.organizations)
    return { repoGroups: [] }

  var orgIds = Object.keys(state.organizations)
  // Group all the repositories under groups of owners
  var reposGroupedByOwners = {
    [state.user.id]: [],
  }
  orgIds.forEach(id => reposGroupedByOwners[id] = [])

  Object.keys(state.repositories).forEach(repoId => {

    var repo = state.repositories[repoId]
    var repoArray = reposGroupedByOwners[repo.ownerId]
    if (repoArray === undefined){
      //throw new Error(`Unknown repository owner "${repo.ownerId}".`)
      // We can hit here if its a repo the user doesn't own but they
      // can collaborate on. In this case add it to the current users
      // group
      repoArray = reposGroupedByOwners[state.user.id]
    }
    repoArray.push(repo.id)
    repoArray.sort(function(a, b){
      var repoA = state.repositories[a], repoB = state.repositories[b]
      if (repoA.updatedAt < repoB.updatedAt)
        return 1
      if (repoA.updatedAt > repoB.updatedAt)
        return -1
      return 0
    })
  })
  // Convert eh grouped by owners object into an array that's easier to
  // consume i.e. the following format
  /* var repoGroups = [
    {
      title: 'AlastairTaft',
      repositories: [ 'asdad', 'asdad' ]
    },
    ... etc
  ] */
  var repoGroups = [
    {
      ownerId: state.user.id,
      title: state.user.name,
      repositories: reposGroupedByOwners[state.user.id],
    }
  ]
  delete reposGroupedByOwners[state.user.id]
  Object.keys(reposGroupedByOwners).forEach(orgId => {
    var org = state.organizations[orgId]
    repoGroups.push({
      ownerId: org.id,
      title: org.name,
      repositories: reposGroupedByOwners[orgId],
    })
  })

  return {
    repoGroups,
  }
}

const Container = ({ repoGroups }) => {
  return <Page>
    {repoGroups.map(({ title, repositories, ownerId }, i) =>
      <RepositorySelectGroup ownerId={ownerId} title={title} first={i == 0}>
        {repositories.map(repoId => <RepositorySelect id={repoId} />)}
      </RepositorySelectGroup>
    )}
  </Page>
}

export default withRouter(connect(mapStateToProps)(Container))


// WEBPACK FOOTER //
// ./src/pages/RepositorySelect/Container.js